import usePublicPostApi from '~/public/lib/usePublicPostApi.js';
import { useEffect, useState } from 'react';
import { useEventTypesQuery } from '~/lib/SharedQueries.js';
import { humanGrantRedeemableAmount } from '~/lib/PackageHelpers.js';
import { formatDateShort } from '~/lib/DateTime.js';
import { isAdminApp } from '~/public/lib/PageHelpers.js';
import { FormPart, part } from '~/lib/FormCssApi';

const PackageGrantBalances = ({grants, results}) => {
    const { data: eventTypesData } = useEventTypesQuery();

    return (
        <div className="mt-4 panel p-4">
            {grants.length === 0 && (
                <div className="text-gray-500">
                    {results?.hasGrantsUnderDifferentName
                        ? 'Package/subscription found for this email address, but name does not match.'
                        : 'No packages or subscriptions found for this email and name. Try a different email or name.'}
                </div>
            )}
            {grants.map((grant, idx) => (
                <div key={idx} className={`${idx > 0 ? 'mt-2' : ''}`}>
                    <div>
                                <span className="font-medium">
                                    {grant.package?.name || 'Unknown Package'}
                                </span>
                        :{' '}
                        {humanGrantRedeemableAmount(
                            grant,
                            eventTypesData,
                        )}
                    </div>
                    {!!grant?.is_expired && !!grant?.expires_at && (
                        <div className="text-gray-500">
                            Expired {formatDateShort(grant?.expires_at)}
                        </div>
                    )}
                </div>
            ))}
        </div>
    )
}

const ShowPackageBalance = ({ settings, email, name }) => {
    const [grants, setGrants] = useState(null);
    const [results, setResults] = useState({});
    const { save: check, isSaving: isChecking } = usePublicPostApi(
        `/public-packages/balance`,
    );


    useEffect(() => {
        // Reset on email change
        setGrants(null);
    }, [email]);

    function doCheck() {
        setGrants(null);
        check({
            email: email,
            name: name,
        }).then(result => {
            setGrants(result?.grants || []);
            setResults(result);
        });
    }

    if (!settings?.showPackageBalanceEmail) {
        return null;
    }

    return (
        <div>
            <div
                className={`flex items-center justify-end ${isAdminApp() ? 'max-w-lg' : 'max-w-xs'} `}
            >
                {grants?.length > 0 && (
                    <button
                        {...part(FormPart.PACKAGE_BALANCE_LINK)}
                        type="button"
                        className="link !no-underline text-sm"
                        onClick={() => setGrants(null)}
                    >
                        - Hide Package/Subscription Balance
                    </button>
                )}
                {!grants?.length && (
                    <button
                        {...part(FormPart.PACKAGE_BALANCE_LINK)}
                        type="button"
                        className="link !no-underline text-sm"
                        onClick={() => doCheck()}
                    >
                        {isChecking
                            ? 'Checking...'
                            : '+ Show Package/Subscription Balance'}
                    </button>
                )}
            </div>
            {Array.isArray(grants) && (
                <PackageGrantBalances grants={grants} results={results} />
            )}
        </div>
    );
};

export default ShowPackageBalance;
